import { useTranslation } from "react-i18next";
import { comparisonData } from "@/mocks/categories";

export default function ComparisonTable() {
  const { t } = useTranslation();

  const renderStars = (count: number) => {
    return (
      <div className="flex items-center gap-0.5">
        {[1, 2, 3, 4, 5].map((star) => (
          <div key={star} className="w-3.5 h-3.5 flex items-center justify-center">
            <i
              className={`text-xs ${
                star <= count
                  ? "ri-star-fill text-primary-500"
                  : "ri-star-line text-foreground-300"
              }`}
            ></i>
          </div>
        ))}
      </div>
    );
  };

  return (
    <section className="py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 text-center mb-10">
          {t("comparison.title")}
        </h2>

        <div className="overflow-x-auto rounded-xl border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-100/80">
                <th className="text-left py-4 px-5 font-heading font-semibold text-foreground-950">
                  Funkcja
                </th>
                <th className="text-center py-4 px-5 font-heading font-semibold text-primary-600">
                  USFans Spreadsheet
                </th>
                <th className="text-center py-4 px-5 font-heading font-semibold text-foreground-700">
                  Excel
                </th>
                <th className="text-center py-4 px-5 font-heading font-semibold text-foreground-700">
                  Notion
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr
                  key={idx}
                  className={`border-t border-background-200/50 ${
                    idx % 2 === 0 ? "bg-background-50" : "bg-background-100/30"
                  }`}
                >
                  <td className="py-3.5 px-5 font-medium text-foreground-800">
                    {row.feature}
                  </td>
                  <td className="py-3.5 px-5">
                    <div className="flex justify-center">{renderStars(row.usfans)}</div>
                  </td>
                  <td className="py-3.5 px-5">
                    <div className="flex justify-center">{renderStars(row.excel)}</div>
                  </td>
                  <td className="py-3.5 px-5">
                    <div className="flex justify-center">{renderStars(row.notion)}</div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}